export const FETCH_PARTNERS_LIST_START = 'FETCH_PARTNERS_LIST_START';
export const FETCH_PARTNERS_LIST_SUCCESS = 'FETCH_PARTNERS_LIST_SUCCESS';
export const FETCH_PARTNERS_LIST_FAILURE = 'FETCH_PARTNERS_LIST_FAILURE';

export const FETCH_PARTNERS_MORE_LIST_START = 'FETCH_PARTNERS_MORE_LIST_START';
export const FETCH_PARTNERS_MORE_LIST_SUCCESS = 'FETCH_PARTNERS_MORE_LIST_SUCCESS';
export const FETCH_PARTNERS_MORE_LIST_FAILURE = 'FETCH_PARTNERS_MORE_LIST_FAILURE';